var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"u-cursor-pointer",attrs:{"type":"button","data":"basket-line-item-remove","aria-label":_vm.t('Shared.Basket.RemoveItem')},on:{"click":_setup.removeFromBasket}},[_c('IconClose',{staticClass:"sub-lg:u-scale-80"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }